import { StyleSheet, View } from 'react-native';
import Modal from '../../modal';
import TextLato from '../../../text/text-lato/TextLato';
import {
  MultiplePurchaseContainer,
  MultiplePurchaseContent,
} from '../../../multiple-purchase-content/MultiplePurchaseContent';
import { useStore } from '../../../../contexts/StoreContext';
import { TestIDs } from 'src/constants/testIDs.constants';
import { DynamicModalProps } from '../DynamicModal.types';
import { CornerRadius } from 'src/theme-v2/corner-radius';

export const ModalMultiplePurchase = ({ dynamicModalVisible, type, dynamicModalLayer: { id } }: DynamicModalProps) => {
  const {
    dynamicModal,
    i18n,
    project: { activeProject, addProducts },
  } = useStore();

  const { closeModal } = dynamicModal;

  const handlePressOption = () => {
    closeModal();
    addProducts();
  };

  return (
    activeProject && (
      <Modal
        visible={dynamicModalVisible}
        onClose={closeModal}
        showHeader={false}
        style={style.modal}
        style_container={style.content}
        testID={TestIDs.MULTIPLE_PURCHASES}
        type={type}
        id={id}
      >
        <View style={style.header}>
          <TextLato style={style.title}>{i18n.t('modal-multiple-purchase:title')}</TextLato>
          <TextLato style={style.description}>{i18n.t('modal-multiple-purchase:description')}</TextLato>
        </View>
        <View>
          <MultiplePurchaseContent container={MultiplePurchaseContainer.MODAL} onPressOption={handlePressOption} />
        </View>
      </Modal>
    )
  );
};

const style = StyleSheet.create({
  modal: {
    height: 461,
    paddingTop: 32,
    paddingBottom: 40,
    paddingHorizontal: 34,
    borderRadius: 20,
    maxWidth: 1040,
  },
  content: {
    paddingHorizontal: 0,
    paddingTop: 0,
    paddingBottom: 0,
    gap: 39,
    borderRadius: CornerRadius.Huge,
  },
  header: {
    gap: 8,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 32,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    textAlign: 'center',
  },
  optionsContainer: {
    flexDirection: 'row',
    gap: 28,
  },
});
